export const SECRET_KEY = "It is secret key";
export const userTypes = {
  BRANCH: "BRANCH",
  OMTK: "OMTK",
  OZL: "OZL",
  DEPARTMENT: "DEPARTMENT",
};

export const INVENTARIZATION_STATUSES = {
  START: "START",
  STOP: "STOP",
  NOT_START: "NOT_START",
};

export const TABLES = {
  Order: {
    index: 0,
    name: "Order",
    slug: "_Order",
  },
  Contract: {
    index: 1,
    name: "Contract",
    slug: "_Contract",
  },
};
export const WAREHOUSE_RECEIVED_TYPE = {
  PARTITION: "PARTITION",
  LOT: "LOT",
};
export const SIGNED_USER_DATA_TYPE = {
  OrderItem: "OrderItem",
  ContractItem: "ContractItem",
};

export const orderStatus = {
  /**
   **  @orderStatus
   */
  NEW: "NEW",
  NOT_ACCEPTED_ORDER: "NOT_ACCEPTED_ORDER",
  ACCEPTED_ORDER: "ACCEPTED_ORDER",
};

export const PRODUCT_ITEM_STATUS = {
  NEW: "NEW",
  PRODUCT_PRODUCED: "PRODUCT_PRODUCED",
  PRODUCT_USED: "PRODUCT_USED",
};

export const orderItemStatus = {
  NEW: "NEW",
  TO_REVIEW_WAREHOUSE: "TO_REVIEW_WAREHOUSE",
  REJECT_ORDER_ITEM: "REJECT_ORDER_ITEM",
  PAPER_EXPECTED_SPECIFICATION: "PAPER_EXPECTED_SPECIFICATION",
  OZL_TO_DEPARTMENT: "OZL_TO_DEPARTMENT",
  PENDING_PURCHASE: "PENDING_PURCHASE",
  DELIVERY_EXPECTED: "DELIVERY_EXPECTED",
  APPLICATION_REJECTED_OZL: "APPLICATION_REJECTED_OZL",
  PRODUCT_DELIVERED: "PRODUCT_DELIVERED",
  YES_PRODUCT: "YES_PRODUCT",
  READY_TO_PRODUCE: "READY_TO_PRODUCE",
  ISSUED_ORDER_ITEM: "ISSUED_ORDER_ITEM",
  RECEIVED: "RECEIVED",
  COMPLETED: "COMPLETED",
};

/**
 *
 * package types
 */

export const PACKAGE_TYPES = ["COUNTABLE", "PACKAGEABLE"];

export const contractStatus = {
  /**
   * * Contract status
   * */
  CONTRACT_CONCLUTION: "CONTRACT_CONCLUTION",
  CONTRACT_ACCEPTED: "CONTRACT_ACCEPTED",
  PART_ACCEPTED: "PART_ACCEPTED",
  CONTRACT_REJECT: "CONTRACT_REJECT",
  CONTRACT_ITEM_PARTITION_ACCEPTED: "CONTRACT_ITEM_PARTITION_ACCEPTED",
};
/**
 * * Contract item status
 * */
export const contractItemStatus = {
  NEW: "NEW",
  CONTRACT_ITEM_ACCEPTED: "CONTRACT_ITEM_ACCEPTED",
  CONTRACT_ITEM_REJECT: "CONTRACT_ITEM_REJECT",
  CONTRACT_ITEM_PART_ACCEPTED: "CONTRACT_ITEM_PART_ACCEPTED",
  CONTRACT_ITEM_PARTITION_ACCEPTED: "CONTRACT_ITEM_PARTITION_ACCEPTED",
};

export const OUT_GOING_CONTRACT_STATUS = {
  /**
   * *outgoing contract status
   */
  CONCLUDED: "CONCLUDED",
  COMPLETED: "COMPLETED",
};

// export const dateFormatFull = "YYYY-MM-DD HH:MM:SS";

export const dateFormat = "DD-MM-YYYY";

export const categoryKey = "Type";
export const productKey = "Product";

export const deliveryTypes = [
  {
    name: "import",
    value: "Import",
  },
  {
    name: "internal",
    value: "Internal",
  },
];

export const INITIATOR_STATUS_TYPE = {
  NEW: "NEW",
  ACCEPTED: "ACCEPTED",
  PART_ACCEPTED: "PART_ACCEPTED",
  WAITING: "WAITING",
  REJECTED: "REJECTED",
};

export const PERMISSIONS = {
  //   KELAJAK UCHUN
  DIVISION_ORDER: "DIVISION_ORDER",
  OMTK_PRODUCT: "OMTK_PRODUCT",
  SETTINGS: "SETTINGS",
  //   ESKILARi
  ALL_PRODUCT: "ALL_PRODUCT",
  ORDER_ITEM_ATTACH_AKT_FILES: "ORDER_ITEM_ATTACH_AKT_FILES",
  WAREHOUSE_INCOME: "WAREHOUSE_INCOME",
  DASHBOARD: "DASHBOARD",
  "DEPARTMENT.CREATE.REQUEST": "ORDER_CREATE",
  "DEPARTMENT.UPDATE.REQUEST": "ORDER_CREATE",
  "DEPARTMENT.DELETE.REQUEST": "ORDER_DELETE",
  "DEPARTMENT.VIEW.REQUEST": "DEPARTMENT_ORDER_READ",
  "DEPARTMENT.SEND.REQUEST": "ORDER_SEND_TO_OMTK",
  DEPARTMENT: "DEPARTMENT_ORDER_READ",
  //department
  OMTK: "OMTK_ORDER_READ",
  "OMTK.SEND.ORDER": "ORDER_ITEM_STATUS_TENDER",
  "OMTK.CALCULATION.ORDER": "ORDER_ITEM_OPPORTUNITY",
  "OMTK.REJECT.ORDER": "ORDER_ITEM_STATUS_REJECT",
  "OMTK.APPROVE.ORDER": "ORDER_ITEM_STATUS_ACCEPT",
  //omtk
  OZL: "OZL_ORDER_READ",
  ORDER_ITEM_STATUS_REJECT_OZL: "ORDER_ITEM_STATUS_REJECT_OZL",
  CONTRACT_CREATE: "CONTRACT_CREATE",
  CONTRACT_ITEM_CREATE: "CONTRACT_ITEM_CREATE",
  CONTRACT_ITEM_CREATE_OZL: "CONTRACT_ITEM_CREATE_OZL",
  CONTRACT_ITEM_ACCEPT: "CONTRACT_ITEM_ACCEPT",
  CONTRACT_ITEM_REJECT: "CONTRACT_ITEM_REJECT",
  CONTRACT_AGGREMENT_FILE_DELETED: "CONTRACT_AGGREMENT_FILE_DELETED",
  CONTRACT_DELETE: "CONTRACT_DELETE",
  CONTRACT_AGGREMENT_FILE_ADD: "CONTRACT_AGGREMENT_FILE_ADD",
  CONTRACT_REJECT: "CONTRACT_REJECT",
  CONTRACT_CREATE_OZL: "CONTRACT_CREATE_OZL",
  CONTRACT: "CONTRACT",
  ORDER_ITEM_STATUS_ACCEPT: "ORDER_ITEM_STATUS_ACCEPT",
  CONTRACT_ITEM_DELETE: "CONTRACT_ITEM_DELETE",
  //ozl
  REFERENCE: "REFERENCE",
  REFERENCE_COLUMN: "REFERENCE_COLUMN",
  USER: "USER",
  //realization
  REALIZATION: "REALIZATION",
  INVENTORY: "INVENTORY",
  "WRITE.OFF": "WRITE.OFF",
  //product
  PRODUCT: "PRODUCT",
  PRODUCT_UPDATE: "PRODUCT_UPDATE",
  PRODUCT_DELETE: "PRODUCT_DELETE",
  PRODUCT_CREATE: "PRODUCT_CREATE",
  PRODUCT_HISTORY: "PRODUCT_HISTORY",
  //
  TMS: "PRODUCT",
  HISTORY: "HISTORY",
  INDEX: "INDEX",

  SEE_ALL_PRODUCTS_IN_WAREHOUSE: "SEE_ALL_PRODUCTS_IN_WAREHOUSE",
  WAREHOUSE: "WAREHOUSE",
  WAREHOUSE_CREATE: "WAREHOUSE_CREATE",
  ZONE_ACTIONS: "ZONE_ACTIONS",
  MOVE_PRODUCT: "MOVE_PRODUCT",
  ORDER_CHANGE_STATE: "ORDER_CHANGE_STATE",
  CONTRACT_CHANGE_STATE: "CONTRACT_CHANGE_STATE",
  RESTORE: "RESTORE",
  REPORTING: "REPORTING",
  INCOME_PRODUCT_FROM_EXCEL: "INCOME_PRODUCT_FROM_EXCEL",

  //   QR CODE PERMISSION
  PRINT_QR_CODE: "PRINT_QR_CODE",

  //   SUPPLIER
  SUPPLIER_READ: "SUPPLIER_READ",
  SUPPLIER_CREATE: "SUPPLIER_CREATE",
  SUPPLIER_ACTION: "SUPPLIER_ACTION",
};

export const USER_CONFIG = {
  DIGITAL_SIGNATURE: "digitalSignature",
};

export const USER_ROLES = {
  OZL: "OZL",
  OMTK: "OMTK",
  DEPARTMENT: "Department",
  TMS: "TMS",
  REALIZATOR: "REALIZATOR",
  ADMIN: "ADMIN",
};

export const ADDITIONAL_ROLES = {
  SEE_HIDDEN_WAREHOUSE: "SEE_HIDDEN_WAREHOUSE",
  SEE_ALL_PRODUCTS_IN_WAREHOUSE: "SEE_ALL_PRODUCTS_IN_WAREHOUSE",
};

/*
Document formats
 */

export const documentFormats = [
  // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  "application/pdf",
  // 'text/plain',
  "image/png",
  "image/jpeg",
  "image/gif",
  // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  // 'application/msword'
];

export const WS_EVENT_TYPES = {
  ORDER_CREATE_EVENT: "ORDER_CREATE_EVENT",
  ORDER_SEND_EVENT: "ORDER_SEND_EVENT",
  ORDER_ITEM_CREATE_EVENT: "ORDER_ITEM_CREATE_EVENT",
  ORDER_ITEM_UPDATE_EVENT: "ORDER_ITEM_UPDATE_EVENT",
  ORDER_ITEM_DELETE_EVENT: "ORDER_ITEM_DELETE_EVENT",
  ORDER_ITEM_CHANGE_STATUS_EVENT: "ORDER_ITEM_CHANGE_STATUS_EVENT",
  ORDER_ITEM_CHANGE_STATUS_REJECT_EVENT:
    "ORDER_ITEM_CHANGE_STATUS_REJECT_EVENT",
  ORDER_ITEM_CREATE_OMTK_TENDER_EVENT: "ORDER_ITEM_CREATE_OMTK_TENDER_EVENT",
  CONTRACT_REJECTED_EVENT: "CONTRACT_REJECTED_EVENT",
  CONTRACT_ACCEPTED_EVENT: "CONTRACT_ACCEPTED_EVENT",
  CONTRACT_CREATE_EVENT: "CONTRACT_CREATE_EVENT",
};

export const LANGUAGES = [
  {
    title: "En",
    key: "en",
  },
  {
    title: "Ру",
    key: "ru",
  },
  {
    title: "Ўз",
    key: "cyrl",
  },
  {
    title: "Uz",
    key: "uz",
  },
];

export const FIELD_TYPES = [
  {
    text: "corridor",
    value: "Corridor",
  },
  {
    text: "field",
    value: "Field",
  },
  {
    text: "stillage",
    value: "Stillage",
  },
];

export const DEPARTMENT_TYPES = [
  {
    text: "department",
    value: "DEPARTMENT",
  },
  {
    text: "omtk",
    value: "OMTK",
  },
  {
    text: "ozl",
    value: "OZL",
  },
  {
    text: "accountant",
    value: "ACCOUNTANT",
  },
];

export const TIME_FILTER_TYPE = {
  month: "Month",
  year: "Year",
  allTime: "Date",
};

export const WAREHOUSE_BOX_STATUS = {
  EMPTY: "EMPTY",
  HALF_EMPTY: "HALF_EMPTY",
  FULL: "FULL",
  NOT_CONFIGURED: "NOT_CONFIGURED",
};

export const DEFAULT_STILLAGE_BOX_SIZE = 120;
